import React from 'react'
import { Pagination } from 'antd'
import { inject, observer } from 'mobx-react'
import { AppTablePagination } from '../../components/AppTable/AppTablePagination'

const stylePagination = {
  display: 'flex',
  justifyContent: 'flex-end',
  marginTop: 20,
  marginBottom: 10,
}

const ProposalAdvanceListPagination = props => {
  const { proposalAdvanceStore } = props

  const handleChangePagination = (page, size) => {
    proposalAdvanceStore.setQueryParams('filterPage', page - 1)
    proposalAdvanceStore.setQueryParams('filterSize', size)
  }
  return (
    <AppTablePagination
      current={proposalAdvanceStore.filterPage + 1}
      pageSize={proposalAdvanceStore.filterSize}
      total={proposalAdvanceStore.proposalAdvanceTotal}
      onChange={handleChangePagination}
    />
  )
}

ProposalAdvanceListPagination.propTypes = {}
export default inject('proposalAdvanceStore')(
  observer(ProposalAdvanceListPagination)
)
